import type { ReactNode, SuspenseProps } from 'react'
import { useLayoutEffect } from 'react'
import { observer } from 'mobx-react-lite'
import type { Theme } from 'theme-ui'
import { ThemeUIProvider } from 'theme-ui'
import createCache from '@emotion/cache'
import { CacheProvider, Global } from '@emotion/react'
import { ErrorBoundary } from '@sentry/react'

import { getBrandAlias } from '@jotta/config/brand'

import { ErrorPageBasic as ErrorPage } from '../../Elements/ErrorPage/ErrorPageBasic'
import type { BrandTheme } from '../../types/BrandTheme'
import { setBodyThemeClassName } from '../../utils/setBodyTheme'
import { getbrandStore } from '../BrandStore/BrandStore'
import { ThemeContextProvider } from '../ThemeProvider/ThemeProvider'

import { BrandContextProvider } from './BrandProvider'

const myCache = createCache({
  key: 'jotta',
})
myCache.compat = true
export const BaseBrandProvider = observer<{
  theme: BrandTheme
  fallback?: SuspenseProps['fallback']
  children?: ReactNode
}>(function BaseBrandProvider({ theme, children }) {
  useLayoutEffect(() => {
    setBodyThemeClassName(theme.branding.brand)
  }, [theme])
  return (
    <ThemeContextProvider brandAlias={getBrandAlias(theme.branding.brand)}>
      <CacheProvider value={myCache}>
        <Global styles={getbrandStore(theme).globalStyles} />
        <ThemeUIProvider theme={theme as any as Theme}>
          <BrandContextProvider theme={theme}>
            <ErrorBoundary
              fallback={({ error, resetError }) => (
                <ErrorPage error={error} resetError={resetError} />
              )}
            >
              {children}
            </ErrorBoundary>
          </BrandContextProvider>
        </ThemeUIProvider>
      </CacheProvider>
    </ThemeContextProvider>
  )
})
